import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

// 공통 AttendState 컴포넌트
export const AttendState = ({ state }) => {
  const styles = {
    ATTENDANCE: { background: "#0D6EFD", textColor: "text-white", imgSrc: "assets/img/attendance.png" },
    LATE: { background: "#FFC107", textColor: "", imgSrc: "assets/img/late.png" },
    EXCUSED_ABSENCE: { background: "#198754", textColor: "text-white", imgSrc: "assets/img/excused_absence.svg" },
    ABSENCE: { background: "#DC3545", textColor: "text-white", imgSrc: "assets/img/absence.png" },
  };
  const currentStyle = styles[state] || { background: "#6C757D", textColor: "", imgSrc: "" };

  return (
    <div
      className={`py-1 px-2 rounded-5 attendance-font-size ${currentStyle.textColor}`}
      style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px" }}
    >
      {currentStyle.imgSrc && <img src={currentStyle.imgSrc} alt={state} style={{ width: "12px", height: "12px" }} />}
    </div>
  );
};

// 공통 DropdownStateSelector 컴포넌트
export const DropdownStateSelector = ({
  state,
  onSelect,
  globalIndex,
  period,
}) => {
  const borderClass = period === 1 ? "border-bottom-0" : "border-top-0";

  return (
    <td
      className={`align-middle border ${borderClass} border-start-0 border-end-0 text-center`}
    >
      <DropdownButton
        title={
          <AttendState state={state} />
        }
        variant={
          state === "ABSENCE"
            ? "danger"
            : state === "LATE"
            ? "warning"
            : state === "EXCUSED_ABSENCE"
            ? "success"
            : "primary"
        }
        onSelect={(eventKey) => onSelect(globalIndex, eventKey)}
      >
        {["ATTENDANCE", "LATE", "EXCUSED_ABSENCE", "ABSENCE"].map((option) => (
          <Dropdown.Item eventKey={option} key={option}>
            <AttendState state={option} />
          </Dropdown.Item>
        ))}
      </DropdownButton>
    </td>
  );
};

export const AttendanceTable = ({ attendanceStatus, handleStatusChange, data }) => {
  return (
    <table>
      <tbody>
        {data.map((item) => (
          <tr key={item.globalIndex}>
            <DropdownStateSelector
              state={attendanceStatus[item.globalIndex]}
              onSelect={handleStatusChange}
              globalIndex={item.globalIndex}
              period={item.period}
            />
          </tr>
        ))}
      </tbody>
    </table>
  );
};
